export default "/images/copy.svg?ed076fef86e43c420d2e9132a3458b70";